import React, { useCallback, useEffect, useState } from 'react'
import styles from '../../css/style.module.css'
import { AddSubCategoryChild, DeleteSuccessfullyModal, SuccessfullyModal } from '../../components/Modals/Modals';
import { deleteApi, getApi, putApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import HOC from '../../components/HOC/HOC'
import { Link } from 'react-router-dom';
import Pagination from '../../components/Pagination/Pagination';
import StatusToggle from '../../components/StatusToggle/StatusToggle';


import img from '../../assest/loading1.gif'

import { RiDeleteBin6Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import { IoSearchSharp } from "react-icons/io5";



const columns = ['S.no', 'SubCategory Child Name', "SubCategory Name", "Price", "For Staff Price", "Total Time(hours)", "Total Minutes", 'Is Product', 'Status', 'Action'];




const SubCategoryChild = () => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [subcategorychilds, setSubCategoryChilds] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedSubCategorychild, setSelectedSubCategoryChild] = useState(null);
    const [search, setSearch] = useState('')
    const [pagination, setPagination] = useState({
        limit: 5,
        totalPages: 1,
        page: 1,
        hasPrevPage: false,
        hasNextPage: false,
    });



    const fetchData = useCallback(async () => {
        await getApi(endPoints.getallsubcategorychildPaginate(pagination.page, pagination.limit, search), {
            setResponse: setSubCategoryChilds,
            setLoading: setLoading,
            errorMsg: "Failed to fetch SubCategory Child!",
        });
    }, [pagination.page, pagination.limit, search]);


    useEffect(() => {
        setPagination((prevPagination) => ({
            ...prevPagination,
            totalPages: subcategorychilds?.data?.totalPages,
            hasPrevPage: subcategorychilds?.data?.hasPrevPage,
            hasNextPage: subcategorychilds?.data?.hasNextPage,
        }));
    }, [subcategorychilds]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);



    const handleDelete = async () => {
        if (!selectedSubCategorychild) return;

        await deleteApi(endPoints.deletesubcategorychild(selectedSubCategorychild), {
            setLoading,
            // successMsg: "SubCategory deleted successfully!",
            errorMsg: "Failed to delete subcategory!",
        });

        fetchData();
        setShowDeleteModal(false);
        setShowSuccessModal(true);
        setTimeout(() => setShowSuccessModal(false), 2000);

    };


    const handleToggleStatus = async (item, nextHidden) => {
        await putApi(
            endPoints.updatesubcategorychildstatus(item._id),
            { isHidden: nextHidden },
            {
                setLoading,
                successMsg: nextHidden
                    ? 'Sub Category Child hidden successfully!'
                    : 'Sub Category Child shown successfully!',
                errorMsg: 'Failed to update subcategory child status!',
            }
        );
        fetchData();
    };

    const openDeleteModal = (categoryId) => {
        setSelectedSubCategoryChild(categoryId);
        setShowDeleteModal(true); // Open confirm delete modal
    };

    const openEditModal = (category) => {
        setSelectedSubCategoryChild(category);
        setEditMode(true);
        setShowAddModal(true);
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setPagination({ ...pagination, page: 1 }); // Reset to the first page on search
    };

    const routeMapping = {
        Category: "/job-management/category",
        SubCategory: "/job-management/subcategory",
        "SubCategory Child": "/job-management/subcategory-child",
        Product: "/job-management/products",
    };

    return (
        <>
            <DeleteSuccessfullyModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleConfirm={handleDelete}
                text="Delete Sub Category Child"
            />
            <SuccessfullyModal
                show={showSuccessModal}
                handleClose={() => setShowSuccessModal(false)}
                text="Successfully Deleted"
            />
            <AddSubCategoryChild
                show={showAddModal}
                onHide={() => setShowAddModal(false)}
                SubCategorychild={fetchData}
                data={selectedSubCategorychild}
                edit={editMode}
            />
            <div className={styles.jobmanagementCotainer}>
                <div className={styles.jobtoppart}>
                    <div className={styles.pagetitle}>
                        <h6>Job Management</h6>
                        <div className={styles.searchbarnav}>
                            <IoSearchSharp color='#8A8A8A' size={20} />
                            <input
                                type="search"
                                placeholder="Search"
                                value={search}
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>
                    <div className={styles.rightbuttons}>
                        <div className={styles.rightbuttons2} onClick={() => {
                            setEditMode(false);
                            setShowAddModal(true);
                        }}>
                            <FaPlus color='#FFFFFF' />
                            <p>Create Subcategory Child</p>
                        </div>
                    </div>
                </div>
                <div className={styles.jobselectcontainer}>
                    <div className={styles.jobStatusContainer}>
                        {['Category', 'SubCategory', 'SubCategory Child', 'Product'].map((item, index) => (
                            <Link key={index} to={routeMapping[item]} className={styles.link}>
                                <p
                                    className={
                                        item === 'SubCategory Child'
                                            ? styles.jobOptionTrueactive
                                            : styles.jobOptionnotactive
                                    }
                                >
                                    {item}
                                </p>
                            </Link>
                        ))}
                    </div>
                </div>
                <div className={styles.jobchildcontainer}>
                    <div className={styles.tablecontainer}>
                        <table className={styles.table1}>
                            <thead>
                                <tr>
                                    {columns.map((label, index) => (
                                        <th key={index} className={styles.tableHeader}>{label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ?
                                    <tr>
                                        <td colSpan="10" style={{ textAlign: "center", padding: "1rem" }}>
                                            <img src={img} alt="" width={100} height={100} />
                                        </td>
                                    </tr>
                                    :
                                    subcategorychilds?.data?.docs?.length === 0 ?
                                        <tr>
                                            <td colSpan="10" style={{ textAlign: "center", padding: "1rem" }}>
                                                No data available.
                                            </td>
                                        </tr>
                                        :
                                        subcategorychilds?.data?.docs?.map((item, rowIndex) => (
                                            <tr key={rowIndex} className={styles.tableRow}>
                                                <td className={styles.tableCell}>
                                                    {rowIndex + 1}
                                                </td>
                                                <td className={styles.tableCell}>
                                                    {item?.name}
                                                </td>
                                                <td className={styles.tableCell}>
                                                    {item?.subCategoryId?.name}
                                                </td>
                                                <td className={styles.tableCell}>
                                                    ₹{item?.price}
                                                </td>
                                                <td className={styles.tableCell}>
                                                    ₹{item?.forStaffPrice}
                                                </td>
                                                <td className={styles.tableCell}>
                                                    {item?.totalTime}
                                                </td>
                                                <td className={styles.tableCell}>
                                                    {item?.totalMin}m
                                                </td>
                                                <td className={styles.tableCell}>
                                                    {item?.isProduct ? "Yes" : "No"}
                                                </td>
                                                <td className={styles.tableCell}>
                                                    <StatusToggle
                                                        isHidden={item?.isHidden}
                                                        onChange={(next) => handleToggleStatus(item, next)}
                                                    />
                                                </td>
                                                <td>
                                                    <div className={styles.tableaction}>
                                                        <FaRegEdit size={20} onClick={() => openEditModal(item)} style={{ cursor: "pointer", color: "#e9b44a" }} />
                                                        <RiDeleteBin6Line
                                                            size={20}
                                                            onClick={() => openDeleteModal(item._id)}
                                                            style={{ cursor: "pointer", color: "#d9534f" }}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        limit={pagination.limit}
                        totalPages={pagination.totalPages}
                        page={pagination.page}
                        hasPrevPage={pagination.hasPrevPage}
                        hasNextPage={pagination.hasNextPage}
                        onPageChange={(newPage) => setPagination({ ...pagination, page: newPage })}
                    />
                </div>

            </div >
        </>
    )
}

export default HOC(SubCategoryChild)
